import React from 'react';
import ActivityIndicator from '../../Components/Playgrond/ActivityIndicator';
import {Grid} from 'tabler-react';

const Loading = () => {
    return (
        <Grid.Col width="12">
            <p className="d-flex align-items-center justify-content-center" style={{height: '200px'}}>
                <ActivityIndicator width="25" height="25" /> Carregando...
            </p>
        </Grid.Col>
    );
};

export default Loading;